import React, { useEffect, useState } from 'react'
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup'
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import Select from 'react-select';

import { InfoAlert } from '../../CommonUtils/SweetAlerts';
export default function AfflTotalCollegesCategoryWiseReport() {
    const [showCategorywiseDetails, setCategorywiseDetails] = useState([]);
    const [universityList, setUniversityList] = useState([]);
    const [clgwiseDetails, setClgwiseDetails] = useState([]);
    const [categorywiseTable, setCategorywiseTable] = useState(false)
    const [showCategoryName, setCategoryName] = useState("")
    const [showDrillCount, setDrillCount] = useState();
    const formik = useFormik({
        initialValues: {
            acyear: "",
            university: "",
            inistType: []
        },
        validationSchema: Yup.object({
            acyear: Yup.string().required(ERROR_MSG).nullable(),
            university: Yup.string().required(ERROR_MSG).nullable(),

            inistType: Yup.array().min(1, "Please select at least one institute type").nullable(),

        }),
        onSubmit: (values) => {
            const selected_list = Array.isArray(values.inistType)
                ? values.inistType.map(item => item.value).join(',')
                : '';


            let acYearOld = ""
            if (values?.acyear === "2026-27") { acYearOld = "2025-26" }
            else if (values?.acyear === "2024-25") { acYearOld = "2023-24" }
            // let url = config.url.API_URL + "getcollegesabstract/" + acYearOld + "/" + values?.acyear + "/" + values?.inistType + "/" + values?.university;
            let url = config.url.API_URL + "getcollegesabstract/" + acYearOld + "/" + values?.acyear + "/" + selected_list + "/" + values?.university
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    setCategorywiseDetails(res?.data?.data)
                    setDrillCount(0);
                    setCategorywiseTable(true)
                }
                else if (res?.data?.scode === '02') {
                    InfoAlert("No Data Found")
                }
            })
        }
    })
    const Columns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },
        {
            Header: "University Name", accessor: "ub_name", Footer: "",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.ub_name}</div>
            ),
        },
        {
            Header: "Total colleges", accessor: "total_coll",
            Cell: ({ row }) => (
                <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                    onClick={() => {
                        GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 1);
                        setCategoryName("Total colleges -  " + row?.original?.ub_name)
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 1);
                            setCategoryName("Total colleges - " + row?.original?.ub_name)
                        }
                    }}  >{row?.values?.total_coll}</div>
            ),
            Footer: "total_coll"
        },
        {
            Header: `College Application ${formik?.values?.acyear}`,
            columns: [
                {
                    Header: "Submitted", accessor: "coll_app",
                    Cell: ({ row }) => (
                        <div
                            style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 2);
                                setCategoryName("Colleges Submission - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 2);
                                    setCategoryName("Colleges Submission - " + row?.original?.ub_name)
                                }
                            }}
                        >{row?.values?.coll_app}</div>
                    ),
                    Footer: "coll_app"
                },
                {
                    Header: "Not Submitted", accessor: "coll_not_sub",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 3);
                                setCategoryName("Not Submitted Colleges - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 3);
                                    setCategoryName("Not Submitted Colleges - " + row?.original?.ub_name)
                                }
                            }}>{row?.values?.coll_not_sub}</div>
                    ),
                    Footer: "coll_not_sub"
                },
            ],
        },
        {
            Header: `FFCA Status ${formik?.values?.acyear}`,
            columns: [
                {
                    Header: "Submitted", accessor: "ffca_done",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 4);
                                setCategoryName("FFCA Submitted Colleges - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 4);
                                    setCategoryName("FFCA Submitted Colleges - " + row?.original?.ub_name)
                                }
                            }}
                        >{row?.values?.ffca_done}</div>
                    ),
                    Footer: "ffca_done"
                },
                {
                    Header: "Not Submitted", accessor: "ffca_notdone",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 5);
                                setCategoryName("FFCA Not Submitted Colleges - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 5);
                                    setCategoryName("FFCA Not Submitted Colleges - " + row?.original?.ub_name)
                                }
                            }}
                        >{row?.values?.ffca_notdone}</div>
                    ),
                    Footer: "ffca_notdone"
                },
            ],
        },
        {
            Header: "CDC Dean Approval",
            columns: [
                {
                    Header: "Approved", accessor: "cdc_confirm",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 6);
                                setCategoryName("CDC Approved Colleges - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 6);
                                    setCategoryName("CDC Approved Colleges - " + row?.original?.ub_name)
                                }
                            }}
                        >{row?.values?.cdc_confirm}</div>
                    ),
                    Footer: "cdc_confirm"
                },
                {
                    Header: "Not Approved", accessor: "cdc_not_confirm",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 7);
                                setCategoryName(" CDC Not Approved Colleges - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 7);
                                    setCategoryName(" CDC Not Approved Colleges - " + row?.original?.ub_name)
                                }
                            }}
                        >{row?.values?.cdc_not_confirm}</div>
                    ),
                    Footer: "cdc_not_confirm"
                },
            ],
        },
        {
            Header: `Affiliation Order Generated ${formik?.values?.acyear}`,
            columns: [
                {
                    Header: "Generated", accessor: "affl_order",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 8);
                                setCategoryName("Affiliation Order Generated Colleges - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 8);
                                    setCategoryName("Affiliation Order Generated Colleges - " + row?.original?.ub_name)
                                }
                            }}
                        >{row?.values?.affl_order}</div>
                    ),
                    Footer: "affl_order"
                },
                {
                    Header: "Not Generated", accessor: "affl_order_not",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 9);
                                setCategoryName("Affiliation Order Not Generated Colleges - " + row?.original?.ub_name)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GetTotalCollegeCategorywiseDetails(formik?.values?.acyear, formik?.values?.inistType, row?.original?.ub_code, 9);
                                    setCategoryName("Affiliation Order Not Generated Colleges - " + row?.original?.ub_name)
                                }
                            }}
                        >{row?.values?.affl_order_not}</div>
                    ),
                    Footer: "affl_order_not"
                },
            ],
        },

    ]

    const totalcollegeColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1 },
        {
            Header: "College Code", accessor: "coll_code",
        },
        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },
        {
            Header: "College Type", accessor: "coll_nature_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coll_nature_name}</div>
            ),
        },
    ]
    function GetUniversityListDetails() {
        let url = config.url.API_URL + `getuniversitydata`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setUniversityList(res?.data?.data)
            }
            else {
                setUniversityList([])
            }
        })
    }


    function GetTotalCollegeCategorywiseDetails(acYear, inst_type, ubCode, level) {
        const InstType = Array.isArray(inst_type)
            ? inst_type?.map(item => item.value).join(',')
            : '';
        let acyearold = ""
        if (acYear === "2026-27") { acyearold = "2024-25" }
        else if (acYear === "2024-25") { acyearold = "2023-24" }

        // let url = config.url.API_URL + "gettotalcolleges/" + acyearold + "/" + acYear + "/" + inst_type + "/" + ubCode + "/" + level;
        let url = config.url.API_URL + "gettotalcolleges/" + acyearold + "/" + acYear + "/" + InstType + "/" + ubCode + "/" + level;

        CommonAxiosGet(url).then((res) => {

            if (res?.data?.scode === '01') {
                setClgwiseDetails(res?.data?.data)
                setDrillCount(1);
                setCategorywiseTable(true)
            }
            else {
                setClgwiseDetails([])
            }
        })
    }



    useEffect(() => { GetUniversityListDetails() }, [])
    function isBackFunction() {
        setDrillCount(showDrillCount - 1)
    }

    const options = [
        { value: '', label: '--select--' },
        { value: 'Engineering', label: 'Engineering' },
        { value: 'B.ED', label: 'B.ED' },
        { value: 'Pharmacy', label: 'Pharmacy' },
        { value: 'Law', label: 'Law' },
        { value: 'Management', label: 'PG' },
    ];



    return (
        <div>
            <bie.Container fluid className="px-1" >
                <FormikProvider value={formik}>
                    <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form" >
                        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">

                            {categorywiseTable === false ?
                                <>

                                    <div className="inner-herbpage-service-title-sub pt-0"  > <h1>Total Colleges Report</h1> </div>
                                    <bie.Row className="my-3 px-3">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                            <label classname='mb-1' className="label-text-style"><b className='mt-2' style={{ color: 'red' }}>* </b>Academic Year</label>
                                            <Field as="select" name="acyear" className="form-control mb-2" onChange={(e) => {
                                                formik?.setFieldValue("university", "");
                                                formik?.setFieldValue("inistType", []);

                                                setCategorywiseDetails([]);
                                            }}>
                                                <option value=''>--select--</option>
                                                <option value="2026-27">2026-27</option>
                                                <option value="2024-25">2024-25</option>
                                            </Field>
                                            <ErrorMessage name="acyear" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                            <label classname='mb-1' className="label-text-style">
                                                <b className='mt-2' style={{ color: 'red' }}>* </b>University</label>
                                            <Field as="select" name="university" className="form-control mb-2" onChange={(e) => {
                                                formik?.setFieldValue("inistType", []);
                                                setCategorywiseDetails([]);
                                            }} >
                                                <option value=''>--select--</option>
                                                <option value="999">All</option>
                                                {universityList && universityList?.map((rel, i) => (
                                                    <option value={rel?.ub_code}>{rel?.ub_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="university" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                            <label classname='mb-1' className="label-text-style">
                                                <b className='mt-2' style={{ color: 'red' }}>* </b>Institute Type </label>
                                            {/* <Field as="select" name="inistType" className="form-control mb-2"
                                                onChange={(e) => { setCategorywiseDetails([]) }} >
                                                <option value=''>--select--</option>
                                                <option value="Engineering">Engineering</option>
                                                <option value="B.ED">B.ED</option>
                                                <option value="Pharmacy">Pharmacy</option>
                                                <option value="Law">Law</option>
                                                <option value="Management">PG</option>
                                            </Field> */}

                                            {/* <Select
                                                name='inistType'
                                                options={options}
                                                isMulti
                                                value={selectedOptions}
                                                onChange={setSelectedOptions}
                                            /> */}


                                            <Select
                                                name="inistType"
                                                options={options}
                                                isMulti
                                                value={formik.values.inistType}
                                                onChange={(value) => formik.setFieldValue("inistType", value)}
                                                onBlur={() => formik.setFieldTouched("inistType", true)}
                                                className="mb-2"
                                            />

                                            <ErrorMessage name="inistType" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-4'>
                                            <button type='submit' className="btn btn-primary btn-sm " >Get Report</button> </bie.Col>
                                    </bie.Row>  </> :

                                <>
                                    {(showDrillCount === 0) && (
                                        <bie.Row className="my-3 px-3">
                                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                                <div className="inner-herbpage-service-title-sub pt-0"  > <h1>Total Colleges Report -
                                                    ({formik?.values?.inistType?.length > 0
                                                        ? formik.values.inistType.map(item => item.label).join(', ')
                                                        : ''})
                                                    -{formik?.values?.acyear}</h1> </div>
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                                <button type='button' className="btn btn-primary btn-sm" onClick={() => { setCategorywiseTable(false) }} >Back</button>
                                            </bie.Col>
                                            <div className="table-responsive">
                                                <CommonReactTable data={showCategorywiseDetails} columns={Columns} filename="Total Colleges Report"
                                                    headerName={`Total Colleges Report`} showFooter={"true"} />
                                            </div>
                                        </bie.Row>
                                    )}
                                    {(showDrillCount === 1) && (
                                        <bie.Row className="my-3 px-3">
                                            <div className="inner-herbpage-service-title-sub pt-0"  > <h1>{showCategoryName}
                                            </h1> </div>

                                            <div className="table-responsive">
                                                <CommonReactTable data={clgwiseDetails} columns={totalcollegeColumns} filename={showCategoryName}
                                                    headerName={showCategoryName} isBack={true} isBackFunction={isBackFunction} />
                                            </div>
                                        </bie.Row>
                                    )}
                                </>}
                        </bie.Container>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </div>
    )
}
